<div class="avatar-group">
  @for (avatar of displayedAvatars; track $index) {
    <div class="avatar"
      [ngStyle]="{ width: computedWidth, height: computedHeight }"
      >
      @if (enableClickTooltip) {
        <button
          type="button"
          class="avatar-trigger"
          [matMenuTriggerFor]="avatarInfoMenu"
          (click)="onAvatarClick(avatar, $event)">
          @if (avatar?.url) {
            <img [src]="avatar.url" [alt]="avatar.name" class="cursor-pointer"
              [ngStyle]="{ width: computedWidth, height: computedHeight }" />
            @if (showStatusIndicator) {
              <span [innerHTML]="loginUserID == avatar?.staffID ? statusSvg : avatar.statusSvg"
                class="status-icon"
              [ngStyle]="{ right: dynamicStatusIconRight, bottom: dynamicStatusIconBottom }"></span>
            }
          }
          @if (!avatar?.url) {
            <div class="cursor-pointer avatar-initials"
              [ngStyle]="{ width: computedWidth, height: computedHeight, 'font-size': dynamicFontSize }">
              {{ getInitials(avatar.name) }}
            </div>
            @if (showStatusIndicator) {
              <span [innerHTML]="loginUserID == avatar?.staffID ? statusSvg : avatar.statusSvg"
                class="status-icon"
              [ngStyle]="{ right: dynamicStatusIconRight, bottom: dynamicStatusIconBottom }"></span>
            }
          }
        </button>
      }
      @if (!enableClickTooltip) {
        @if (avatar?.url) {
          <img [src]="avatar.url" [alt]="avatar.name" class="cursor-pointer"
            [matTooltip]="getAvatarTooltip(avatar)"
            [matTooltipDisabled]="!showHoverLabel || !getAvatarTooltip(avatar)"
            matTooltipPosition="below"
            [ngStyle]="{ width: computedWidth, height: computedHeight }" />
          @if (showStatusIndicator) {
            <span [innerHTML]="loginUserID == avatar?.staffID ? statusSvg : avatar.statusSvg"
              class="status-icon"
            [ngStyle]="{ right: dynamicStatusIconRight, bottom: dynamicStatusIconBottom }"></span>
          }
        }
        @if (!avatar?.url) {
          <div class="cursor-pointer avatar-initials"
            [matTooltip]="getAvatarTooltip(avatar)"
            [matTooltipDisabled]="!showHoverLabel || !getAvatarTooltip(avatar)"
            matTooltipPosition="below"
            [ngStyle]="{ width: computedWidth, height: computedHeight, 'font-size': dynamicFontSize }">
            {{ getInitials(avatar.name) }}
          </div>
          @if (showStatusIndicator) {
            <span [innerHTML]="loginUserID == avatar?.staffID ? statusSvg : avatar.statusSvg"
              class="status-icon"
            [ngStyle]="{ right: dynamicStatusIconRight, bottom: dynamicStatusIconBottom }"></span>
          }
        }
      }
    </div>
  }

  @if (remainingCount > 0) {
    <div class="cursor-pointer avatar-more" [matMenuTriggerFor]="remainingMenu"
      (click)="onMoreClick()"
      [ngStyle]="{ width: dynamicMoreButtonSize, height: dynamicMoreButtonSize, 'font-size': dynamicMoreButtonFontSize }">
      +{{ remainingCount }}
    </div>
  }
</div>

<mat-menu #avatarInfoMenu="matMenu" class="avatar-info-menu" (closed)="onMenuClosed()">
  @if (selectedAvatarForMenu) {
    <div class="avatar-info-content">
      {{ getAvatarTooltip(selectedAvatarForMenu) }}
    </div>
  }
</mat-menu>

<mat-menu #remainingMenu="matMenu" class="menu-container" (closed)="onMenuClosed()">
  @for (avatar of remainingAvatars; track $index) {
    @if (!avatar?.url) {
      <div class="menu-header" (click)="onMenuItemClick(avatar.action, $event)">
        <div class="profile-circle" [matTooltip]="getAvatarTooltip(avatar)"
          [ngStyle]="{ width: computedWidth, height: computedHeight, 'font-size': dynamicFontSize }">
          {{ getInitials(avatar.name) }}
        </div>
        @if (showStatusIndicator) {
          <span [innerHTML]="loginUserID == avatar?.staffID ? statusSvg : avatar.statusSvg"
            class="status-icon-indicator-on-remaining-menu"
          [ngStyle]="{ right: dynamicStatusIconRight, bottom: dynamicStatusIconBottom }"></span>
        }
        <div class="user-info">
          <div class="name">
            {{ avatar.name }}
          </div>
          @if (useDetailedTooltip && avatar?.roles?.length) {
            <div class="role-details">
              {{ getAvatarRolesLabel(avatar) }}
            </div>
          }
        </div>
      </div>
    }
    @if (avatar?.url) {
      <div style="cursor: pointer; margin-left: 10px; position: relative;" class="d-flex align-items-center"
        (click)="onMenuItemClick(avatar.action, $event)">
        <img [src]="avatar?.url" alt="user_profile_image" class="mt-2 mb-2 mr-2 avatar_img user-image rounded-circle"
          [matTooltip]="getAvatarTooltip(avatar)"
          [ngStyle]="{ width: computedWidth, height: computedHeight }" />
        @if (showStatusIndicator) {
          <span [innerHTML]="loginUserID == avatar?.staffID ? statusSvg : avatar.statusSvg"
            class="status-icon-indicator-on-remaining-menu"
          [ngStyle]="{ right: dynamicStatusIconRight, bottom: dynamicStatusIconBottom }"></span>
        }
        <div class="user-info">
          <div class="name">{{ avatar.name }}</div>
          @if (useDetailedTooltip && avatar?.roles?.length) {
            <div class="role-details">
              {{ getAvatarRolesLabel(avatar) }}
            </div>
          }
        </div>
      </div>
    }
  }
</mat-menu>